var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoReporting24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_reporting24x24",
    transform: "translate(-21.833 -572.999)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M32.4,7.588a1.387,1.387,0,0,0,.976-.4l1.385.7a1.4,1.4,0,1,0,2.65-.437l1.875-1.9a1.372,1.372,0,0,0,.6.143,1.406,1.406,0,0,0,1.332-1.845l1.633-1.241a1.389,1.389,0,0,0,1.721-.133A1.435,1.435,0,0,0,44.869.749,1.4,1.4,0,0,0,43.291.042a1.405,1.405,0,0,0-.991,1.8L40.673,3.084a1.383,1.383,0,0,0-1.7.1,1.429,1.429,0,0,0-.34,1.691l-1.882,1.9a1.366,1.366,0,0,0-1.573.257l-1.385-.7A1.4,1.4,0,1,0,32.4,7.587Zm0,0",
    transform: "translate(-8.186 573)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M15.531,160.325h-.5v-9.859a.467.467,0,0,0-.468-.466H12.686a.467.467,0,0,0-.468.466v9.859H11.28v-7.059a.467.467,0,0,0-.468-.466H8.937a.467.467,0,0,0-.468.466v7.059H7.531V157a.467.467,0,0,0-.468-.466H5.187a.467.467,0,0,0-.468.466v3.328H3.781v-5.194a.467.467,0,0,0-.468-.466H1.437a.467.467,0,0,0-.468.466v5.193h-.5a.467.467,0,1,0,0,.933H15.531a.467.467,0,1,0,0-.933Zm0,0",
    transform: "translate(21.834 427.742)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoReporting24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_reporting24x24.69f487ae477694573a7380b78f9aa084.svg";